import styled from "@emotion/styled";

export const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  "& > *:first-of-type": {
    marginBottom: "12px",
  },
});
